module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_cdp-713581881faa56781807f809757cef3c.png";